import { render, staticRenderFns } from "./arrearageOrder.vue?vue&type=template&id=0ceed3c4&scoped=true"
import script from "./arrearageOrder.vue?vue&type=script&lang=js"
export * from "./arrearageOrder.vue?vue&type=script&lang=js"
import style0 from "./arrearageOrder.vue?vue&type=style&index=0&id=0ceed3c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ceed3c4",
  null
  
)

export default component.exports